import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "@/store/index";
import { selectUserData } from "../user/selectors";

export const selectAppointment = (state: RootState) => state.appointment;

export const selectAppointmentLoading = createSelector(
  selectAppointment,
  (appointment) => appointment.loading,
);

export const selectAppointmentData = createSelector(
  selectAppointment,
  (appointment) => appointment.appointment,
);

export const selectAppointmentIsAppointment = createSelector(
  selectAppointmentData,
  (appointment) => !!appointment,
);

export const selectAppointmentUserIsDoctor = createSelector(
  [
    selectAppointmentData,
    selectUserData,
  ],
  (appointment, user) => user && appointment && Number(user.id) === Number(appointment.doctor_id),
);

export const selectAppointmentUserAvatar = createSelector(
  [
    selectAppointmentData,
    selectAppointmentUserIsDoctor,
  ],
  (appointment, isDoctor) => {
    if (isDoctor) {
      return appointment?.patient.avatar;
    }

    return appointment?.doctor.avatar;
  },
);

export const selectAppointmentUserName = createSelector(
  [
    selectAppointmentData,
    selectAppointmentUserIsDoctor,
  ],
  (appointment, isDoctor) => {
    if (isDoctor) {
      return `${appointment?.patient.first_name || ''} ${appointment?.patient.last_name || ''}`;
    }

    return `${appointment?.doctor.first_name || ''} ${appointment?.doctor.last_name || ''}`;
  },
);

export const selectAppointmentPatientId = createSelector(
  selectAppointmentData,
  (appointment) => {
    return appointment?.patient_id;
  },
);

export const selectAppointmentPatientName = createSelector(
  selectAppointmentData,
  (appointment) => {
    return `${appointment?.patient.first_name || ''} ${appointment?.patient.last_name || ''}`;
  },
);

export const selectAppointmentDoctorName = createSelector(
  selectAppointmentData,
  (appointment) => {
    return `${appointment?.doctor.first_name || ''} ${appointment?.doctor.last_name || ''}`;
  },
);

export const selectAppointmentMessages = createSelector(
  selectAppointmentData,
  (appointment) => {
    return appointment?.notes || [];
  },
);

export const selectAppointmentFiles = createSelector(
  selectAppointmentData,
  (appointment) => {
    return appointment?.files || [];
  },
);

export const selectAppointmentLinks = createSelector(
  selectAppointmentData,
  (appointment) => {
    return appointment?.links || [];
  },
);
